<template>
  <pop-up-message :message="message" v-if="isMessageVisible" v-on:close="isMessageVisible=false"/>

  <page-scaffold>
    <div class="balance-page">
      <div class="history-header" style="grid-area: title-history">
        <div class="history-header__title">История платежей</div>
        <button type="button" class="history-header__filter" @click="openFilterDialog">
          <span class="history-header__filter-icon" aria-hidden="true">
            <svg viewBox="0 0 24 25">
              <path d="M16.75 4.06V2.5C16.75 2.09 16.41 1.75 16 1.75C15.59 1.75 15.25 2.09 15.25 2.5V4H8.75V2.5C8.75 2.09 8.41 1.75 8 1.75C7.59 1.75 7.25 2.09 7.25 2.5V4.06C4.55 4.31 3.24 5.92 3.04 8.31C3.02 8.6 3.26 8.84 3.54 8.84H20.46C20.75 8.84 20.99 8.59 20.96 8.31C20.76 5.92 19.45 4.31 16.75 4.06Z" fill="#24484e"/>
              <path d="M20 10.34H4C3.45 10.34 3 10.79 3 11.34V17.5C3 20.5 4.5 22.5 8 22.5H16C19.5 22.5 21 20.5 21 17.5V11.34C21 10.79 20.55 10.34 20 10.34ZM9.21 18.71C9.16 18.75 9.11 18.8 9.06 18.83C9 18.87 8.94 18.9 8.88 18.92C8.82 18.95 8.76 18.97 8.7 18.98C8.63 18.99 8.57 19 8.5 19C8.37 19 8.24 18.97 8.12 18.92C7.99 18.87 7.89 18.8 7.79 18.71C7.61 18.52 7.5 18.26 7.5 18C7.5 17.74 7.61 17.48 7.79 17.29C7.89 17.2 7.99 17.13 8.12 17.08C8.3 17 8.5 16.98 8.7 17.02C8.76 17.03 8.82 17.05 8.88 17.08C8.94 17.1 9 17.13 9.06 17.17C9.11 17.21 9.16 17.25 9.21 17.29C9.39 17.48 9.5 17.74 9.5 18C9.5 18.26 9.39 18.52 9.21 18.71ZM9.21 15.21C9.02 15.39 8.76 15.5 8.5 15.5C8.24 15.5 7.98 15.39 7.79 15.21C7.61 15.02 7.5 14.76 7.5 14.5C7.5 14.24 7.61 13.98 7.79 13.79C8.07 13.51 8.51 13.42 8.88 13.58C9.01 13.63 9.12 13.7 9.21 13.79C9.39 13.98 9.5 14.24 9.5 14.5C9.5 14.76 9.39 15.02 9.21 15.21ZM12.71 18.71C12.52 18.89 12.26 19 12 19C11.74 19 11.48 18.89 11.29 18.71C11.11 18.52 11 18.26 11 18C11 17.74 11.11 17.48 11.29 17.29C11.66 16.92 12.34 16.92 12.71 17.29C12.89 17.48 13 17.74 13 18C13 18.26 12.89 18.52 12.71 18.71ZM12.71 15.21C12.66 15.25 12.61 15.29 12.56 15.33C12.5 15.37 12.44 15.4 12.38 15.42C12.32 15.45 12.26 15.47 12.2 15.48C12.13 15.49 12.07 15.5 12 15.5C11.74 15.5 11.48 15.39 11.29 15.21C11.11 15.02 11 14.76 11 14.5C11 14.24 11.11 13.98 11.29 13.79C11.38 13.7 11.49 13.63 11.62 13.58C11.99 13.42 12.43 13.51 12.71 13.79C12.89 13.98 13 14.24 13 14.5C13 14.76 12.89 15.02 12.71 15.21ZM16.21 18.71C16.02 18.89 15.76 19 15.5 19C15.24 19 14.98 18.89 14.79 18.71C14.61 18.52 14.5 18.26 14.5 18C14.5 17.74 14.61 17.48 14.79 17.29C15.16 16.92 15.84 16.92 16.21 17.29C16.39 17.48 16.5 17.74 16.5 18C16.5 18.26 16.39 18.52 16.21 18.71ZM16.21 15.21C16.16 15.25 16.11 15.29 16.06 15.33C16 15.37 15.94 15.4 15.88 15.42C15.82 15.45 15.76 15.47 15.7 15.48C15.63 15.49 15.56 15.5 15.5 15.5C15.24 15.5 14.98 15.39 14.79 15.21C14.61 15.02 14.5 14.76 14.5 14.5C14.5 14.24 14.61 13.98 14.79 13.79C14.89 13.7 14.99 13.63 15.12 13.58C15.3 13.5 15.5 13.48 15.7 13.52C15.76 13.53 15.82 13.55 15.88 13.58C15.94 13.6 16 13.63 16.06 13.67C16.11 13.71 16.16 13.75 16.21 13.79C16.39 13.98 16.5 14.24 16.5 14.5C16.5 14.76 16.39 15.02 16.21 15.21Z" fill="#24484e"/>
            </svg>
          </span>
          <span>Период</span>
        </button>
      </div>
      <div class="balance-up" style="margin-top: 32px; height: 100%">
        <div class="title" style="color: white; margin-top: 0">Пополнить баланс</div>
        <div class="v-search-bar">
          <input class="sum" type="text" onkeyup="this.value = this.value.replace(/[^\d]/g,'');" placeholder="0₽"
                 v-model="amount"/>
        </div>
        <label
          class="autopayment-toggle"
          :class="{ 'autopayment-toggle--disabled': !isAutopaymentServiceAvailable }"
          :aria-disabled="(!isAutopaymentServiceAvailable).toString()"
        >
          <input type="checkbox" v-model="isAutopaymentEnabled" :disabled="!isAutopaymentServiceAvailable">
          <span>Включить автоплатеж</span>
        </label>
        <div
          :class="['btn', { 'btn--disabled': !isSbpPaymentsAvailable }]"
          :aria-disabled="(!isSbpPaymentsAvailable).toString()"
          @click="pay_sbp"
        >
          СБП (без комиссии)
        </div>
        <div class="btn" @click="pay">Банковской картой</div>
        <div
          :class="['btn', { 'btn--disabled': !isSbpPaymentsAvailable }]"
          :aria-disabled="(!isSbpPaymentsAvailable).toString()"
          @click="pay_sbp"
        >
          Цифровой рубль
        </div>
      </div>
      <div class="history">
        <div v-if="rangeLabel" class="history-filter-chip" @click="clearFilter">
          <span>{{ rangeLabel }}</span>
          <span class="history-filter-chip__close" aria-hidden="true">×</span>
        </div>
        <widget-history-skeleton v-if="isHistoryLoading" :count="4" />
        <template v-else>
          <item-payment
              v-for="item in filteredHistory"
              :key="item.id || item.timestamp"
              :item="item"
              @repeat="repeatPayment"
          />
          <div v-if="!filteredHistory.length" class="history-empty">
            Нет платежей за выбранный период
          </div>
        </template>
      </div>
    </div>
  </page-scaffold>

  <transition name="fade">
    <div v-if="isFilterDialogOpen" class="filter-overlay">
      <div class="filter-modal">
        <div class="filter-modal__title">Выберите период</div>
        <div class="filter-modal__inputs">
          <label class="filter-modal__field">
            <span>С</span>
            <input type="date" lang="ru" v-model="filterStart">
          </label>
          <label class="filter-modal__field">
            <span>По</span>
            <input type="date" lang="ru" v-model="filterEnd">
          </label>
        </div>
        <div class="filter-modal__actions">
          <button type="button" class="filter-modal__secondary" @click="closeFilterDialog">Отмена</button>
          <button
              type="button"
              class="filter-modal__secondary"
              v-if="dateRange"
              @click="clearFilterAndClose"
          >
            Сбросить
          </button>
          <button
              type="button"
              class="filter-modal__primary"
              :disabled="isApplyDisabled"
              @click="applyFilter"
          >
            Применить
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import PageScaffold from "./page-scaffold";
import ItemPayment from "./item-payment";
import WidgetHistorySkeleton from "./widget-history-skeleton";
import axios from "axios";
import PopUpMessage from "./pop-up-message";
import {saveAccountServices} from "../utils/multi-account";

const DATE_LABEL_FORMATTER = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: 'short'
});

export default {
  name: "page-balance",
  components: {PopUpMessage, ItemPayment, PageScaffold, WidgetHistorySkeleton},
  data: () => ({
    allHistory: [],
    isHistoryLoading: true,
    amount: "",
    message: "Укажите сумму платежа",
    isMessageVisible: false,
    isFilterDialogOpen: false,
    filterStart: '',
    filterEnd: '',
    dateRange: null,
    isAutopaymentEnabled: false,
    isSbpPaymentsAvailable: true,
    isAutopaymentServiceAvailable: true
  }),
  computed: {
    filteredHistory() {
      if (!this.dateRange) {
        return this.allHistory;
      }
      const { start, end } = this.dateRange;
      return this.allHistory.filter(item => {
        const timestampMs = (item.timestamp || 0) * 1000;
        return timestampMs >= start && timestampMs <= end;
      });
    },
    rangeLabel() {
      if (!this.dateRange) {
        return '';
      }
      const { start, end } = this.dateRange;
      const startLabel = DATE_LABEL_FORMATTER.format(new Date(start));
      const endLabel = DATE_LABEL_FORMATTER.format(new Date(end));
      return `${startLabel} – ${endLabel}`;
    },
    isApplyDisabled() {
      return !this.filterStart || !this.filterEnd;
    }
  },
  methods: {
    pay() {
      const isPhys = localStorage.userType === 'individual';
      if (!isPhys) {
        this.$router.push("/documents?type=1");
        return;
      }

      const amountValue = this.validateAndNormalizeAmount();
      if (amountValue === null) {
        return;
      }

      axios({
        method: 'GET',
        params: {
          amount: amountValue,
          redirectUrl: "https://k.itk-rus.ru/balance"
        },
        url: "v1/payment",
        headers: {Authorization: `Bearer ` + localStorage.token},
      }).then(response => {
        window.open(response.data.paymentUrl, "_self")
      })
    },
    pay_sbp() {
      const isPhys = localStorage.userType === 'individual';
      if (!isPhys) {
        this.$router.push("/documents?type=1");
        return;
      }

      if (!this.isSbpPaymentsAvailable) {
        return;
      }

      const amountValue = this.validateAndNormalizeAmount();
      if (amountValue === null) {
        return;
      }

      axios({
        method: 'GET',
        params: {
          amount: amountValue,
          autopayment: this.isAutopaymentServiceAvailable && this.isAutopaymentEnabled,
          redirectUrl: "https://k.itk-rus.ru/balance"
        },
        url: "v1/payment/qr",
        headers: {Authorization: `Bearer ` + localStorage.token},
      }).then(response => {
        window.open(response.data.paymentUrl, "_self")
      })
    },
    isServiceStatusActive(status) {
      if (status === undefined || status === null) {
        return true;
      }
      return String(status).toLowerCase() === 'active';
    },
    loadServicesAvailabilityFromCache() {
      const raw = localStorage.accountServices;
      if (!raw) {
        return false;
      }
      try {
        const services = JSON.parse(raw);
        this.applyServicesAvailability(services);
        return true;
      } catch (error) {
        saveAccountServices(null);
        return false;
      }
    },
    applyServicesAvailability(services) {
      const normalized = services && typeof services === 'object' ? services : {};
      this.isSbpPaymentsAvailable = this.isServiceStatusActive(normalized.payments_sbp);
      this.isAutopaymentServiceAvailable = this.isServiceStatusActive(normalized.autopayments);
      if (!this.isAutopaymentServiceAvailable) {
        this.isAutopaymentEnabled = false;
      }
    },
    persistAccountServicesCache(services) {
      saveAccountServices(services);
    },
    async fetchServicesAvailability() {
      const headers = {Authorization: `Bearer ${localStorage.token}`};
      try {
        const response = await axios({
          method: "GET",
          url: "v3/account",
          headers
        });
        const v3Data = response?.data ?? null;
        const accountV3 = v3Data && (v3Data.accountData ?? v3Data.account) ? (v3Data.accountData ?? v3Data.account) : null;
        const services = (accountV3 && accountV3.services) || {};
        this.applyServicesAvailability(services);
        this.persistAccountServicesCache(services);
      } catch (error) {
        this.isSbpPaymentsAvailable = true;
        this.isAutopaymentServiceAvailable = true;
      }
    },
    validateAndNormalizeAmount() {
      const raw = (this.amount || '').trim();
      if (!raw) {
        this.message = "Укажите сумму платежа";
        this.isMessageVisible = true;
        return null;
      }

      const numeric = Number(raw);
      if (!Number.isFinite(numeric) || Number.isNaN(numeric)) {
        this.message = "Укажите корректную сумму платежа";
        this.isMessageVisible = true;
        return null;
      }

      if (numeric < 1) {
        this.message = "Сумма платежа должна быть не меньше 1 рубля";
        this.isMessageVisible = true;
        return null;
      }

      return numeric;
    },
    normalizeAmount(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const normalized = String(value).replace(/[^0-9,.-]/g, '').replace(',', '.');
      const parsed = parseFloat(normalized);
      return Number.isNaN(parsed) ? null : parsed;
    },
    formatAmountInput(value) {
      if (!Number.isFinite(value)) {
        return '';
      }
      const normalized = Math.round(value * 100) / 100;
      return Number.isInteger(normalized) ? String(normalized) : String(normalized);
    },
    resolveRepeatMethod(item) {
      const fields = [
        item?.method,
        item?.paymentMethod,
        item?.payment_type,
        item?.provider,
        item?.source,
        item?.description,
        item?.title,
        item?.comment
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      if (fields.includes('sbp') || fields.includes('сбп') || fields.includes('qr')) {
        return 'sbp';
      }
      return 'card';
    },
    repeatPayment(payload) {
      const item = payload && payload.item ? payload.item : payload;
      const amountValue = payload && typeof payload.amount === 'number'
        ? payload.amount
        : this.normalizeAmount(item?.amount);
      if (amountValue === null) {
        this.message = "Не удалось определить сумму платежа";
        this.isMessageVisible = true;
        return;
      }
      this.amount = this.formatAmountInput(amountValue);
      const method = this.resolveRepeatMethod(item);
      if (method === 'sbp' && this.isSbpPaymentsAvailable) {
        this.pay_sbp();
      } else {
        this.pay();
      }
    },
    openFilterDialog() {
      this.isFilterDialogOpen = true;
      if (this.dateRange) {
        this.filterStart = this.toDateInputValue(this.dateRange.start);
        this.filterEnd = this.toDateInputValue(this.dateRange.end);
      } else {
        this.filterStart = '';
        this.filterEnd = '';
      }
    },
    closeFilterDialog() {
      this.isFilterDialogOpen = false;
    },
    clearFilter() {
      this.dateRange = null;
    },
    clearFilterAndClose() {
      this.clearFilter();
      this.closeFilterDialog();
    },
    applyFilter() {
      if (this.isApplyDisabled) {
        return;
      }
      const start = new Date(`${this.filterStart}T00:00:00`).getTime();
      const end = new Date(`${this.filterEnd}T23:59:59`).getTime();
      if (Number.isNaN(start) || Number.isNaN(end)) {
        return;
      }
      const normalizedStart = Math.min(start, end);
      const normalizedEnd = Math.max(start, end);
      this.dateRange = {
        start: normalizedStart,
        end: normalizedEnd
      };
      this.closeFilterDialog();
    },
    toDateInputValue(ms) {
      const date = new Date(ms);
      const iso = date.toISOString();
      return iso.slice(0, 10);
    }
  },
  mounted() {
    this.loadServicesAvailabilityFromCache();
    this.fetchServicesAvailability();
    axios({
      method: "GET",
      url: "v2/payment/history",
      headers: {Authorization: `Bearer ` + localStorage.token},
    }).then(response => {
      const list = Array.isArray(response.data.response) ? response.data.response : [];
      this.allHistory = list.map(entry => {
        const rawType = typeof entry?.type === 'string' ? entry.type.toLowerCase() : '';
        const normalizedType = rawType === 'debit' ? 'debit' : 'payment';
        return {
          ...entry,
          type: normalizedType
        };
      });
    }).catch(() => {
      this.allHistory = [];
    }).finally(() => {
      this.isHistoryLoading = false;
    })
  }
}
</script>

<style scoped>
.balance-page {
  padding-right: 24px;
  width: calc(100%);
  height: 100%;
  overflow-y: hidden;
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-template-rows: max-content max-content 1fr;
  grid-template-areas:
      "balancewidget title-history"
      "balancewidget history"
      "balancewidget history";
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 16px 0 16px;
}

.history-header__title {
  font-family: "Mont", serif;
  font-weight: 700;
  font-size: 1.4rem;
  color: #2D666E;
}

.history-header__filter {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: #f0f6fa;
  color: #24484e;
  padding: 8px 12px;
  border-radius: 14px;
  font-family: "Mont", serif;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.history-header__filter:hover {
  background: #e1edf5;
  box-shadow: 0 6px 16px rgba(36, 72, 78, 0.15);
}

.history-header__filter-icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
}

.balance-up {
  margin-left: 16px;
  text-align: center;
  padding: 16px 0;
  background: #58B1DA;
  margin-right: 16px;
  height: max-content;
  width: 350px;
  border-radius: 24px;
  grid-area: balancewidget;
}

.balance-up .sum {
  width: calc(100% - 48px);
  font-family: "Mont", serif;
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 1.5rem;
  color: white;
  padding-top: 10px;
  padding-bottom: 8px;
  margin-left: 24px;
  margin-right: 24px;
  text-align: center;
  border-width: 0;
  outline: none;
  height: 32px;
  background: #4895b9;
  border-radius: 16px;
}

.title {
  padding-left: 16px;
  font-family: "Century Gothic", serif;
  font-weight: bold;
  color: #2D666E;
  height: max-content;
  justify-self: start;
  white-space: nowrap;
  font-size: 1.4rem;
  margin-top: 24px;
  margin-bottom: 24px;
}

.history {
  grid-area: history;
  overflow-y: auto;
  margin-top: 16px;
  padding: 0px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.history::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.history-filter-chip {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 16px;
  background: rgba(0, 130, 191, 0.12);
  color: #0082bf;
  font-family: "Mont", serif;
  font-weight: 600;
  cursor: pointer;
}

.history-filter-chip__close {
  font-size: 1.1rem;
  line-height: 1;
}

.history-empty {
  font-family: "Mont", serif;
  font-size: 0.95rem;
  color: #6c7b8a;
  padding: 24px 0;
  text-align: center;
}

.btn {
  cursor: pointer;
  padding: 16px 14px 14px 14px;
  background: white;
  margin-right: 24px;
  margin-left: 24px;
  border-radius: 16px;
  box-shadow: 0 0 24px rgba(255, 255, 255, 0.3);
  width: calc(100% - 48px - 28px);
  color: #58B1DA;
  font-family: "Mont", serif;
  font-weight: bolder;
  margin-top: 16px;
  line-height: 1rem;
  font-size: 1rem;
}

.btn:hover {
  box-shadow: 0 0 24px rgba(0, 153, 255, 0.6);
}

.btn--disabled,
.btn--disabled:hover {
  opacity: 0.45;
  cursor: default;
  pointer-events: none;
  box-shadow: none;
}

.autopayment-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  color: white;
  font-family: "Mont", serif;
  font-weight: 600;
  cursor: pointer;
}

.autopayment-toggle input {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.autopayment-toggle--disabled {
  opacity: 0.45;
  cursor: default;
}

.autopayment-toggle--disabled input {
  cursor: not-allowed;
}

.btn-text {
  font-family: "Mont", serif;
  font-weight: bolder;
  margin-top: 16px;
  line-height: 1rem;
  color: white;
}

.v-search-bar {
  margin-top: 16px;
}

.filter-overlay {
  position: fixed;
  inset: 0;
  background: rgba(16, 30, 52, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 2200;
}

.filter-modal {
  width: min(420px, 100%);
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.18);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.filter-modal__title {
  font-family: "Mont", serif;
  font-weight: 700;
  font-size: 1.2rem;
  color: #24484e;
  text-align: center;
}

.filter-modal__inputs {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.filter-modal__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: "Mont", serif;
  color: #4a5a64;
}

.filter-modal__field input {
  border: 1px solid #d6e2eb;
  border-radius: 12px;
  padding: 10px 12px;
  font-family: "Mont", serif;
  font-size: 0.95rem;
  color: #24484e;
}

.filter-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.filter-modal__secondary,
.filter-modal__primary {
  border: none;
  border-radius: 14px;
  padding: 10px 18px;
  font-family: "Mont", serif;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
}

.filter-modal__secondary {
  background: #eef3f7;
  color: #24484e;
}

.filter-modal__primary {
  background: #0082bf;
  color: #ffffff;
}

.filter-modal__primary:disabled {
  background: #a6b4c2;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .balance-page {
    grid-template-columns: 1fr;
    grid-template-areas:
        "title-history"
        "balancewidget"
        "history";
  }

  .balance-up {
    width: 100%;
    margin: 0 0 24px 0;
  }

  .history-header {
    padding: 16px 16px 0 16px;
  }
}
</style>
